export default __webpack_public_path__ + "static/media/gram_hearing.b3e7bda5.svg";